module.exports = __webpack_public_path__ + "static/media/简笔画效果多重预测.6c9955a0.png";